/**
 * Checkout validation.
 *
 * Payment used to be validated here, because checkout collected a card number
 * into a form of its own. Razorpay's hosted checkout collects it now and
 * validates it far better than a regex could — so the only thing left for this
 * side is the delivery address, which is ours to ask for.
 */

export function validateAddress(address) {
  const complete = ['name', 'phone', 'addr', 'city', 'pin'].every((k) => address[k]?.trim());
  return complete ? null : 'Please fill in all address fields.';
}

/**
 * `requiresDelivery` comes from the cart, not the form. A digital order never
 * collects an address, so checking one would block checkout on fields that were
 * never rendered.
 */
export function validateCheckout({ address, requiresDelivery = true }) {
  if (requiresDelivery) return validateAddress(address);
  return null;
}
